module.exports = __webpack_public_path__ + "img/electric-energy-distribution.a1aba8f5.png";